import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5_4.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Z przyjemnością, ale kto to jest Łukaszewski?"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p14,
            }}
            content={
                <div>
                    <ul>
                        <li>A kto to jest ten Łukaszewski?</li>
                        <li>Widać, żeś nie stąd, bo zna go każdy z Zagórowa i okolicznych wiosek… Łukaszewski prowadzi knajpę w samym środku miasteczka, obok synagogi. I dla Polaków, i dla Niemców suty posiłek poda na stół, ale i dla Żydów coś koszernego zawsze się znajdzie! Po tym znać dobrego gospodarza… Sam pędzi gorzałkę, a do niej daje salcesonu własnej roboty. Zobaczysz, nie pożałujesz!</li>
                    </ul>
                </div>
            }
        />

    );
}